import { FC } from "react";
import { PageHeader } from "@/components/ui/PageHeader";

interface IPageTemplateProps {
  title: string;
  description?: string | React.ReactNode;
  children: React.ReactNode;
  rightContent?: React.ReactNode;
}

const PageTemplate: FC<IPageTemplateProps> = ({
  title,
  description,
  children,
  rightContent,
}) => {
  return (
    <div>
      <PageHeader
        title={title}
        description={description}
        rightContent={rightContent}
      />
      {children}
    </div>
  );
};

export default PageTemplate;
